// Material Design
export {
	MdAbc as StringTextIcon,
	MdAccountCircle as AccountCircleIcon,
	MdAccountTree as AccountTreeIcon,
	MdAddCircle as AddCircleIcon,
	MdAlignHorizontalCenter as AlignHorizontalCenterIcon,
	MdAlignHorizontalLeft as AlignHorizontalLeftIcon,
	MdAlignHorizontalRight as AlignHorizontalRightIcon,
	MdArrowBack as ArrowBackIcon,
	MdArrowDropDown as ArrowDropDownIcon,
	MdArrowForward as ArrowForwardIcon,
	MdAssignmentInd as AssignmentIndIcon,
	MdBookmark as BookmarkIcon,
	MdCheck as CheckIcon,
	MdChildFriendly as ChildFriendlyIcon,
	MdClear as ClearIcon,
	MdClose as CloseIcon,
	MdCloud as CloudIcon,
	MdCloudDownload as CloudDownloadIcon,
	MdCode as CodeIcon,
	MdCommit as CommitIcon,
	MdContentCopy as ContentCopyIcon,
	MdContentCopy as CopyIcon,
	MdDataObject as DataObjectIcon,
	MdDelete as DeleteIcon,
	MdDescription as DescriptionIcon,
	MdDns as DnsIcon,
	MdDragIndicator as DragIndicatorIcon,
	MdError as ErrorIcon,
	MdExpandMore as ExpandMoreIcon,
	MdFastForward as FastForwardIcon,
	MdFileCopy as FileCopyIcon,
	MdFolder as FolderIcon,
	MdFolderCopy as FolderCopyIcon,
	MdFormatAlignLeft as TextAlignLeftIcon,
	MdHelp as HelpIcon,
	MdHelpOutline as HelpOutlineIcon,
	MdHistory as HistoryIcon,
	MdHtml as HtmlIcon,
	MdHttp as HttpIcon,
	MdIndeterminateCheckBox as IndeterminateCheckBoxIcon,
	MdKeyboardArrowDown as KeyboardArrowDownIcon,
	MdKeyboardArrowUp as KeyboardArrowUpIcon,
	MdLightMode as LightModeIcon,
	MdDarkMode as DarkModeIcon,
	MdLock as LockIcon,
	MdLogin as LoginIcon,
	MdLogout as LogoutIcon,
	MdMerge as MergeIcon,
	MdMoreHoriz as MoreHorizIcon,
	MdMoreVert as MoreVertIcon,
	MdMoreVert as OverflowMenuVerticalIcon,
	MdNotes as NotesIcon,
	MdNumbers as NumbersIcon,
	MdOutlineAccountCircle as AccountCircleOutlinedIcon,
	MdOutlineAddReaction as AddReactionIcon,
	MdOutlineCopyAll as ReplicateIcon,
	MdOutlineDelete as DeleteOutlineIcon,
	MdOutlineEditAttributes as EditAttributesIcon,
	MdOutlineNorthEast as NorthEastIcon,
	MdOutlinePersonAdd as PersonAddIcon,
	MdOutlineSouthEast as SouthEastIcon,
	MdOutlineSouthWest as SouthWestIcon,
	MdOutlineVisibility as ViewIcon,
	MdOutlineVisibilityOff as ViewOffIcon,
	MdOutlineViewList as ViewListIcon,
	MdOutlineWidgets as WidgetsIcon,
	MdPalette as PaletteIcon,
	MdPictureInPicture as PictureInPictureIcon,
	MdPlayArrow as PlayArrowIcon,
	MdPublic as PublicIcon,
	MdPublicOff as PublicOffIcon,
	MdRadioButtonUnchecked as RadioButtonUncheckedIcon,
	MdRemove as RemoveIcon,
	MdReportProblem as ReportProblemIcon,
	MdRestartAlt as RestartIcon,
	MdSearch as SearchIcon,
	MdSend as SendIcon,
	MdSettings as SettingsIcon,
	MdSupport as SupportIcon,
	MdSwapHoriz as SwapHorizIcon,
	MdSwapVerticalCircle as SwapVerticalCircleIcon,
	MdTextFields as TextFieldsIcon,
	MdThumbUp as ThumbUpIcon,
	MdTripOrigin as TripOriginIcon,
	MdVisibility as VisibilityIcon,
	MdVisibilityOff as VisibilityOffIcon,
} from "react-icons/md";

// Lucide
export {
	LuALargeSmall as FontSizeIcon,
	LuArrowDown as ArrowDownIcon,
	LuArrowLeft as ArrowLeftIcon,
	LuArrowRight as ArrowRightIcon,
	LuArrowUp as ArrowUpIcon,
	LuArrowUpDown as ArrowsVerticalIcon,
	LuArrowDownNarrowWide as SortAscendingIcon,
	LuArrowUpWideNarrow as SortDescendingIcon,
	LuBold as BoldIcon,
	LuCalendar as CalendarIcon,
	LuCalendarClock as EventScheduleIcon,
	LuCheck as CheckmarkIcon,
	LuChevronDown as ChevronDownIcon,
	LuChevronUp as ChevronUpIcon,
	LuChevronLeft as ChevronLeftIcon,
	LuChevronRight as ChevronRightIcon,
	LuCircleAlert as WarningIcon,
	LuClock4 as TimeIcon,
	LuDatabase as DatabaseIcon,
	LuGripVertical as DraggableIcon,
	LuGroup as GroupResourceIcon,
	LuHash as HashtagIcon,
	LuHeading1 as H1Icon,
	LuHeading2 as H2Icon,
	LuHeading3 as H3Icon,
	LuHistory as RecentlyViewed,
	LuInfo as InformationIcon,
	LuItalic as ItalicIcon,
	LuLink as LinkIcon,
	LuList as BulletListIcon,
	LuListChecks as TaskListIcon,
	LuListOrdered as NumberedListIcon,
	LuLock as LockedIcon,
	LuMail as EmailIcon,
	LuMessageCircleMore as AddCommentIcon,
	LuMinus as SubtractIcon,
	LuPanelLeftClose as SidePanelCloseIcon,
	LuPanelLeftOpen as SidePanelOpenIcon,
	LuPanelRightOpen as SidePanelRightOpenIcon,
	LuPercent as PercentageIcon,
	LuPencilLine as EditIcon,
	LuPlus as AddIcon,
	LuRefreshCcw as RefreshIcon,
	LuSettings2 as FeatureFlagIcon,
	LuSmile as FaceActivatedAddIcon,
	LuStrikethrough as StrikethroughIcon,
	LuTag as TagIcon,
	LuTriangleAlert as TriangleWarningIcon,
	LuTriangleAlert as WarningAltIcon,
	LuType as FontFamilyIcon,
	LuUnderline as UnderlineIcon,
	LuUserCheck as UserAdminIcon,
} from "react-icons/lu";

// Font Awesome v6
export {
	FaCaretDown as CaretDownIcon,
	FaCirclePlus as AddFilledIcon,
	FaCircleXmark as MisuseIcon,
	FaCodeBranch as BranchIcon,
	FaMoneyBill as MoneyIcon,
	FaRegCircleCheck as CheckmarkOutlineIcon,
	FaRegSquare as CheckboxIcon,
	FaRegSquareCheck as CheckboxCheckedIcon,
	FaRegTrashCan as TrashIcon,
} from "react-icons/fa6";

// Font Awesome v5/classic
export {
	FaCheckCircle as CheckCircleIcon,
	FaGithub as GitHubIcon,
	FaInfoCircle as InformationCircleIcon,
	FaTable as DataTableIcon,
} from "react-icons/fa";

// Devicons
export { DiPostgresql as PostgresIcon } from "react-icons/di";

// Go Icons
export {
	GoDotFill as DotMarkIcon,
	GoKey as PasswordIcon,
	GoMoveToBottom as DownToBottomIcon,
	GoMoveToTop as UpToTopIcon,
} from "react-icons/go";

// Ionicons 5
export { IoDocumentTextOutline as DocumentIcon } from "react-icons/io5";

// Ionicons 4
export { IoMdCloseCircle as CloseOutlineIcon } from "react-icons/io";

// Remix Icons
export { RiDoubleQuotesL as QuotesIcon, RiProgress3Line as ProgressBarIcon } from "react-icons/ri";

// Ant Design Icons
export {
	AiOutlineDeleteColumn as ColumnDeleteIcon,
	AiOutlineInsertRowBelow as RowInsertIcon,
	AiOutlineTable as TableIcon,
} from "react-icons/ai";

export { PiThumbsUp as ThumbsUpIcon, PiThumbsUpFill as ThumbsUpFilledIcon } from "react-icons/pi";

// Tabler Icons
export {
	TbPin as PinIcon,
	TbPinFilled as PinFilledIcon,
	TbSql as SqlIcon,
	TbInfoSquareFilled as InformationSquareIcon,
} from "react-icons/tb";

// Moment Icons
export { LogoMoment } from "./LogoMoment";
